import { connect } from 'react-redux';
import VendorInformation from './VendorInformation';
import { sites } from '../helpers/globalVariables';

const mapStateToProps = ({ estimateBuilder }) => {
  const { entities, uiState } = estimateBuilder;
  const { estimates } = entities;
  const { selectedEstimate } = uiState;

  const estimate = estimates.byId[selectedEstimate];
  const {
    orderNumber,
    numberOfWindows,
    orderDate,
    serviceProvider,
    technicians,
    serviceProviderPhone,
    jobUid,
  } = estimate && estimate.attributes;

  const currentSite = window.globalConfig.siteId;
  let mandiOrderDetailsUrl = '';
  if (currentSite === sites.theHomeDepot) {
    let { mandiBaseUrl } = window.globalConfig.globalPaths;
    const len = mandiBaseUrl.length;
    if (mandiBaseUrl[len - 1] === '/') {
      mandiBaseUrl = mandiBaseUrl.substring(0, len - 1);
    }
    mandiOrderDetailsUrl = `${mandiBaseUrl}/orderdetail?jobid=${jobUid}`;
  } else {
    mandiOrderDetailsUrl = `${window.location.origin}/mandi/order/${jobUid}`;
  }

  return {
    orderNumber,
    numberOfWindows,
    orderDate,
    serviceProvider,
    technicians: JSON.parse(technicians),
    serviceProviderPhone,
    mandiOrderDetailsUrl,
  };
};

export default connect(mapStateToProps)(VendorInformation);
